<!--
  @Description: 最新直播、直播回放组件
  @Author: sss
  @Date: 2022-05-30
-->
<template>
  <div class="main-container">
    <div class="list-wrap">
      <div class="live-item" v-for="item, index in data" :key="item.id">
        <div class="image" @click="getliveurl(item)">
          <img :src="item.imgUrl" alt="" />
          <div class="time-status foreshow" v-if="item.aliveState == 0"><i class="iconfont">&#xe6c5;</i>距直播还有 <span v-html="diffTime(item.aliveStartAt)"></span></div>
          <div class="time-status playing" v-if="item.aliveState == 1"><i class="iconfont">&#xe6c3;</i>正在直播</div>
          <div class="time-status replay" v-if="item.aliveState == 2"><i class="iconfont">&#xe6c4;</i>直播回放</div>
          <div class="button"><i class="iconfont">&#xe6c6;</i></div>
        </div>
        <div class="status orange" v-if="item.aliveState == 0">直播预估
          {{ item.aliveStartAt | time_moment_second }} - {{ item.aliveStopAt | time_moment_hour }}
        </div>
        <div class="status orange" v-if="item.aliveState == 1">正在直播
          {{ item.aliveStartAt | time_moment_second }} - {{ item.aliveStopAt | time_moment_hour }}
        </div>
        <div class="status" v-if="item.aliveState == 2">直播回放
          {{ item.aliveStartAt | time_moment_second }} - {{  item.aliveManualStopAt ? item.aliveManualStopAt : item.aliveStopAt | time_moment_hour }}
        </div>
        <div class="info" @click="getliveurl(item)">{{item.title}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
export default {
  props: ['data', 'type'],
  created() {

  },
  mounted() {
    this.liveInterval = setInterval(() => {
      this.now_time = moment().unix()
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.liveInterval)
    this.liveInterval = ''
  },
  computed:{
    diffTime() {
      let fm = num => num < 10 ? '0' + num : num
      return function (t) {
        let str = moment(t).unix() - this.now_time
        let h = Math.floor(str / 3600),
            d = Math.floor(h / 24),
            h2 = Math.floor(h % 24),
            m = Math.floor((str % 3600) / 60),
            s = (str % 3600) % 60
        let hh = fm(h2),
            mm = fm(m),
            ss = fm(s)
        let dd = d >= 1 ? d + '天' : ''
        return dd + hh + '时' + mm + '分' + ss + '秒'
      }
    },
    user_key() {
      return this.$store.state.user_key
    },
  },
  data() {
    return {
      liveInterval: '',
      now_time: ''
    }
  },
  methods: {
    getliveurl(item) {
      window.open(item.h5Url)
    },
  }
}
</script>

<style lang="stylus" scoped>
  .main-container
    width 100%
    margin 0 auto
    .list-wrap
      display flex
      flex-direction column
      align-items center
      .live-item
        width 100%
        display flex
        flex-direction column
        .image
          position relative
          margin-bottom .24rem
          img
            width 100%
            height 4.06rem
            object-fit cover
            flex 1
          .time-status
            position absolute
            top 0
            left 0
            height .44rem
            padding .1rem .14rem
            font-size .26rem
            font-weight bold
            color #FFFFFF
            // line-height .44rem
            text-align center
            .iconfont
              font-size .22rem
              margin-right .1rem
          .button
            width .7rem
            height .7rem
            border-radius 50%
            background rgba(0, 0, 0, .6)
            position absolute
            top 50%
            left 50%
            transform translate(-50%, -50%)
            display flex
            align-items center
            justify-content center
            .iconfont
              font-size .27rem
              color #FFFFFF
          .replay
            width 1.68rem
            background rgba(0, 0, 0, .6)
          .playing
            background #FA5A00
            width 1.72rem
          .foreshow
            background #FA5A00
        .status
          font-size .22rem
          height .3rem
          padding .05rem
          font-weight 500
          margin-bottom .24rem
          width fit-content
        .blue
          background #E9F3FF
          color #0177EE
        .orange
          color #FA5A00
          background #FFEFE2
        .info
          font-size .28rem
          font-weight bold
          color #333333
          text-align justify
          margin-bottom .44rem
          line-height .42rem
</style>